import React from 'react';
import { MapPin, CheckCircle, AlertCircle } from 'lucide-react';
import PostcodeAutocomplete from '../PostcodeAutocomplete/PostcodeAutocomplete'; // Adjust path to your existing component
import styles from './LocationInputGroup.module.css';

const LocationInputGroup = ({ 
    label = "Location", 
    value, 
    onLocationSelect, 
    error, 
    suburb, 
    state, 
    disabled = false,
    placeholder = "Suburb, Postcode or Region"
}) => {
    return (
        <div className={styles.container}>
            {label && <label className={styles.label}>{label}</label>}
            
            <div className={error ? styles.autocompleteError : ''}>
                <PostcodeAutocomplete 
                    value={value || ''} // Safety check here
                    onSuggestionSelect={onLocationSelect}
                    disabled={disabled}
                    placeholder={placeholder}
                />
            </div>

            {/* Error Message */}
            {error && (
                <div className={styles.feedbackError}>
                    <AlertCircle size={12} /> {error}
                </div>
            )}

            {/* Success/State Feedback */}
            {!error && state && (
                <div className={styles.feedbackSuccess}>
                    <CheckCircle size={12} /> 
                    <span>
                        {suburb ? `${suburb}, ` : ''}{state} detected
                    </span>
                </div>
            )}
        </div>
    );
};

export default LocationInputGroup;